import './BetbookPostMoreOptionsDialog.less';
import React from 'react';
import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import i18n from '@i18n';

function BetbookInfoDialog({ title, text }) {
    return (
        <Docked className="betbook-post-options-dialog">
            <DialogTitle>
                <h2>{i18n(title)}</h2>
            </DialogTitle>
            <DialogBody className="center-text">
                <p>{i18n(text)}</p>
            </DialogBody>
        </Docked>
    );
}

export default BetbookInfoDialog;
